import { render, staticRenderFns } from "./productDialog.vue?vue&type=template&id=83abc668&scoped=true&"
import script from "./productDialog.vue?vue&type=script&lang=js&"
export * from "./productDialog.vue?vue&type=script&lang=js&"
import style0 from "./productDialog.vue?vue&type=style&index=0&lang=css&"
import style1 from "./productDialog.vue?vue&type=style&index=1&id=83abc668&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83abc668",
  null
  
)

export default component.exports